import { render, staticRenderFns } from "./exhibition-info-edit.vue?vue&type=template&id=2f23abcb&scoped=true&"
import script from "./exhibition-info-edit.vue?vue&type=script&lang=js&"
export * from "./exhibition-info-edit.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-info-edit.vue?vue&type=style&index=0&id=2f23abcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f23abcb",
  null
  
)

export default component.exports